$(document).ready(function() {

  var dirRtlFlag = false;
  if ($("html").attr('dir') == 'rtl') {
    dirRtlFlag = true;
  }

  $('.hp-lior-slider').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    fade: true,
    rtl: dirRtlFlag,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'linear',
    pauseOnHover: false
  });

	$('.social-bus-slider').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		// slidesToShow: 5,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 10000,
		rtl: dirRtlFlag,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$(".numbers-block2").waypoint(function() {

		$({
			blurRadius: 5
		}).animate({
			blurRadius: 0
		}, {
			duration: 1200, 
			easing: 'swing',
			step: function() {
				$(".numbers-block2__number").css({
					"-webkit-filter": "blur(" + this.blurRadius + "px)",
					"filter": "blur(" + this.blurRadius + "px)"
				});
			}
		});
		var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(',');
		$(".numbers-block2__number").each(function() {
			var tcount = $(this).data("count");
			$(this).animateNumber({
					number: tcount,
					easing: 'easeInQuad', 
					"font-size": "32px",
					numberStep: comma_separator_number_step
				},
				1200);
		});
		this.destroy();

	}, {
		offset: '60%'
	});

});



$(document).ready(function() {
	$('.middle-banner').lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: '.middle-banner'
	});
})

$(document).ready(function() {
  var dirRtlFlag = false;
if ($("html").attr('dir') == 'rtl') {
 dirRtlFlag = true;
}

$('.bottom-tv__news').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 100,
  rtl: dirRtlFlag,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
   {
   breakpoint: 1300,
   settings: {
     slidesToShow: 1,
     slidesToScroll: 1,
   }
   },
   {
   breakpoint: 778,
   settings: {
     slidesToShow: 1,
     slidesToScroll: 1
   }
   },
   // You can unslick at a given breakpoint now by adding:
   // settings: "unslick"
   // instead of a settings object
  ] 
  });


  $('.art-slider').slick({
		dots: false,
    arrows: false,
		infinite: true,
		speed: 500,
    fade: true,
    cssEase: 'linear',
		// slidesToShow: 5,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 10000,
		rtl: dirRtlFlag,
	});
})
